import { render } from "./UserAddCredits.vue?vue&type=template&id=61aa47f7&scoped=true"
import script from "./UserAddCredits.vue?vue&type=script&lang=js"
export * from "./UserAddCredits.vue?vue&type=script&lang=js"

import "./UserAddCredits.vue?vue&type=style&index=0&id=61aa47f7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61aa47f7"]])

export default __exports__